module.exports = __webpack_public_path__ + "img/bob.6a4d2b50.png";